import { render, staticRenderFns } from "./PaymentPlatform.vue?vue&type=template&id=2b3f9622&scoped=true"
import script from "./PaymentPlatform.vue?vue&type=script&lang=js"
export * from "./PaymentPlatform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3f9622",
  null
  
)

export default component.exports